<template>
    <v-container v-if="equipamento">
        <v-row class="container-header-tablet">
            <v-col cols="6">
                <v-row>
                    <v-col cols="12">
                        <v-row class="d-flex justify-center align-center">
                            <v-col cols="8">
                                <div class="box-nome">
                                    <label>{{ equipamento.equipamento.nome }}</label>
                                </div>
                            </v-col>
                            <v-col cols="3">
                                <div class="botao-log">
                                    <label class="fonte-clara"></label>
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="margin-top-10">
                        <v-row class="d-flex justify-center align-center">
                            <v-col cols="5">
                                <div class="box-nome">
                                    <label>{{ equipamento.empresa }}</label>
                                </div>
                            </v-col>
                            <v-col cols="6">
                                <router-link
                                    :to="{ name: 'GestaoEnergetica', params: { id: equipamento.idEquipamento || equipamentoId } }"
                                    class="box-gestao-energetica fonte-clara" style="text-decoration: none;">
                                    <font-awesome-icon :icon="['fas', 'solar-panel']" />
                                    <label>Gestão energética</label>
                                </router-link>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12">
                        <BoxDiagnostico :equipamento="equipamento"></BoxDiagnostico>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6" class="d-flex pa-0" style="height: 100%;">
                <v-row class="linha-status-imagem pa-0" align="stretch">

                    <!-- Bloco de Status -->
                    <v-col cols="6" class="d-flex align-center justify-center pa-0">
                        <div class="bloco-status-operacao">
                            <div>
                                <div class="box-titulo-status">
                                    <label class="titulo-status">> Status</label>
                                </div>

                                <div class="container-status">
                                    <div class="box-status">
                                        <div class="box-descricao-status"
                                            :class="[statusOperacao ? 'status-ligado' : 'status-inativo']">
                                            <label class="fonte-clara">LIGADO</label>
                                        </div>
                                    </div>
                                    <div class="box-status">
                                        <div class="box-descricao-status"
                                            :class="[!statusOperacao ? 'status-parado' : 'status-inativo']">
                                            <label class="fonte-clara">PARADO</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="box-operacao">
                                <div class="box-tempo-operacao">
                                    <label class="descricao-tempo">Em Operação</label>
                                    <label class="quantidade-tempo">
                                        {{ horasOperacao !== null ? horasOperacao + ' h' : '---' }}
                                    </label>
                                </div>
                                <div class="botao-log mt-2 ocultar-mobile">
                                    <label class="fonte-clara"></label>
                                </div>
                            </div>
                        </div>
                    </v-col>

                    <!-- Bloco da Imagem -->
                    <v-col cols="6" class="d-flex align-center justify-start pa-0">
                        <div class="imagem-equipamento"
                            :style="{ backgroundImage: 'url(' + equipamento.imagemEquipamento + ')' }"></div>
                    </v-col>

                </v-row>
            </v-col>
        </v-row>

        <v-row class="container-header-mobile ocultar-tablet">
            <v-col cols="12">
                <v-row class="d-flex justify-center align-center">
                    <v-col cols="9">
                        <div class="box-nome">
                            <label>{{ equipamento.equipamento.nome }}</label>
                        </div>
                    </v-col>
                    <v-col cols="3">
                        <div class="botao-log">
                            <label class="fonte-clara"></label>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="margin-top-10">
                <v-row class="d-flex justify-center align-center">
                    <v-col cols="6">
                        <div class="box-nome">
                            <label>{{ equipamento.empresa }}</label>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <router-link
                            :to="{ name: 'GestaoEnergetica', params: { id: equipamento.idEquipamento || equipamentoId } }"
                            class="box-gestao-energetica fonte-clara ocultar-mobile" style="text-decoration: none;">
                            <font-awesome-icon :icon="['fas', 'solar-panel']" />
                            Gestão energética
                        </router-link>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <BoxDiagnostico :equipamento="equipamento"></BoxDiagnostico>
            </v-col>
        </v-row>

        <v-row class="container-dados-equipamento">

            <v-col cols="6" lg="2" md="3" sm="6" xs="12" class="ocultar-tablet">
                <div class="box-titulo-status">
                    <label class="titulo-status"> > Status</label>
                </div>
                <div class="container-status">
                    <div class="box-status">
                        <div class="box-descricao-status"
                            :class="[statusOperacao ? 'status-ligado' : 'status-inativo']">
                            <label class="fonte-clara">LIGADO</label>
                        </div>
                    </div>
                    <div class="box-status">
                        <div class="box-descricao-status"
                            :class="[!statusOperacao ? 'status-parado' : 'status-inativo']">
                            <label class="fonte-clara">PARADO</label>
                        </div>
                    </div>
                </div>
                <div class="box-operacao">
                    <div class="box-tempo-operacao">
                        <label class="descricao-tempo">Em Operação</label>
                        <label class="quantidade-tempo">{{ horasOperacao !== null ? horasOperacao + ' h' : '---'
                            }}</label>
                    </div>
                    <div class="botao-log mt-2 ocultar-mobile">
                        <label class="fonte-clara"></label>
                    </div>
                </div>
            </v-col>

            <v-col cols="6" lg="2" md="3" sm="6" xs="12" class="ocultar-tablet">
                <div class="imagem-equipamento"
                    :style="{ backgroundImage: 'url(' + equipamento.imagemEquipamento + ')' }"></div>
            </v-col>

            <!-- 1) Cabeçalho do bloco -->
            <v-col cols="12" lg="8" md="6" xs="12" class="container-varaiveis-criticas">
                <div class="box-variaveis-criticas">
                    <label>&gt; Variáveis Críticas</label>
                </div>

                <!-- 2) Wrapper grid -->
                <div class="gauges-wrapper">
                    <!-- 3) Cada gauge -->
                    <div v-for="(variavelCritica, index) in variaveisCriticas" :key="index" class="box-gauge">
                        <label class="descricao-variavel-critica">
                            {{ variavelCritica.descricao }}
                        </label>

                        <GaugeGrafico :variavelCritica="variavelCritica" />
                    </div>
                </div>
            </v-col>

        </v-row>
        <v-row>
            <v-col cols="12" lg="4" md="6" xs="12">
                <v-row>
                    <v-col class="ocultar-mobile container-diagnostico" cols="12" lg="12">
                        <BoxDiagnostico :equipamento="equipamento"></BoxDiagnostico>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" lg="6" md="4" xs="12">
                <GraficoVariaveisCriticas :variaveisCriticas="variaveisCriticas"></GraficoVariaveisCriticas>
            </v-col>
            <v-col cols="12" lg="2" md="2" xs="12" style="margin-top: 15px;">
                <v-row>
                    <v-col class="d-flex justify-center" cols="12">
                        <router-link
                            :to="{ name: 'GestaoEnergetica', params: { id: equipamento.idEquipamento || equipamentoId } }"
                            class="box-gestao-energetica fonte-clara ocultar-mobile" style="text-decoration: none;">
                            <font-awesome-icon :icon="['fas', 'solar-panel']" />
                            Gestão energética
                        </router-link>
                    </v-col>
                    <v-col class="d-flex justify-center ocultar-mobile" cols="12">
                        <MapaEquipamento :urlMapa="equipamento.urlMapa"></MapaEquipamento>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="linha-circuito">
            <v-col v-for="(circuito, index) in equipamento.circuitos" :key="index" cols="12" lg="3" md="3" sm="12"
                xs="12">
                <div class="box-circuito" :class="[
                    !circuito.ativo ? 'circuito-desativado' : '',
                    circuitoSelecionado.idCircuito == circuito.idCircuito ? 'circuito-selecionado' : '']"
                    @click="selecionarCircuito(circuito)"
                    :style="{ cursor: circuito.ativo ? 'pointer' : 'not-allowed' }">
                    <p class="fonte-clara">{{ circuito.descricao }}</p>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="linha-titulo-variaveis" cols="12" md="12">
                <div class="box-titulo-variaveis">
                    <label>+ Variáveis</label>
                </div>
            </v-col>
            <v-col v-for="(variavel, index) in variaveisCircuito" :key="index" cols="12" md="4" lg="4" sm="6" xs="12">
                <div class="box-variavel">
                    <label class="label-descricao">{{ variavel.descricao }}</label>
                    <label class="label-valor">{{ variavel.valor }}</label>
                </div>
            </v-col>
        </v-row>
        <div class="rodape-plant">
            Desenvolvido por: <strong>Plant Evolution</strong> ®
        </div>
    </v-container>

</template>

<script>
    import { ref, onMounted, onUnmounted } from "vue";
    import { useRoute } from "vue-router";
    import { eventBus } from "./core/EventBus";
    import axios from "axios";
    import GaugeGrafico from "./GaugeGrafico.vue";

    import GraficoVariaveisCriticas from "./GraficoVariaveisCriticas.vue";
    import MapaEquipamento from "./MapaEquipamento.vue";
    import BoxDiagnostico from "./BoxDiagnostico.vue";

    export default {
        components: { GaugeGrafico, GraficoVariaveisCriticas, MapaEquipamento, BoxDiagnostico },
        setup() {
            const route = useRoute();
            const equipamentoId = route.params.id;
            const statusOperacao = ref(false);
            const equipamento = ref(null);
            const variaveisCriticas = ref(null);
            const erro = ref(null);
            const circuitoSelecionado = ref(null);
            const variaveisCircuito = ref(null);
            const dadosGrafico = ref(null);
            const horasOperacao = ref(null);

            const carregarEquipamento = async () => {
                try {
                    const response = await axios.get(`https://peconnect.com.br/api/equipamento/${equipamentoId}`);
                    equipamento.value = response.data;
                    eventBus.emit('mudou-nome-equipamento', equipamento.value.equipamento.nome);
                    circuitoSelecionado.value = equipamento.value.circuitos[0];
                    buscarVariaveisCirucito();
                    buscarDadosGrafico();
                } catch (error) {
                    erro.value = 'Erro ao carregar os dados do equipamento.';
                    console.error(error);
                }
            };

            const carregarStatus = async () => {
                try {
                    const { data } = await axios.get(
                        `https://peconnect.com.br/api/equipamento/${equipamentoId}/status`
                    );
                    statusOperacao.value = data.statusOperacao;
                } catch (err) {
                    console.error('Erro ao carregar status:', err);
                }
            };

            const selecionarCircuito = (circuito) => {
                if (!circuito.ativo) {
                    return;
                }
                circuitoSelecionado.value = circuito;
                buscarVariaveisCirucito();
            };

            const buscarDadosGrafico = async () => {
                try {
                    const responseGrafico = await axios.get(`https://infinity-refrisat.com/equipamento/${equipamentoId}/grafico-temperatura`);
                    dadosGrafico.value = responseGrafico.data;
                } catch (error) {
                    erro.value = 'Erro ao carregar os dados do grafico.';
                    console.error(error);
                }
            };

            const buscarVariaveisCirucito = async () => {
                try {
                    const responseVariaveis = await axios.get(`https://peconnect.com.br/api/equipamento/${equipamentoId}/variaveis-circuito/${circuitoSelecionado.value.idCircuito}`);
                    variaveisCircuito.value = responseVariaveis.data;
                } catch (error) {
                    erro.value = 'Erro ao carregar as variaveis do cicuito.';
                    console.error(error);
                }
            };

            const carregarVariaveisCriticas = async () => {
                try {
                    const responseVariaveisCriticas = await axios.get(`https://peconnect.com.br/api/equipamento/${equipamentoId}/variaveis-criticas`);
                    variaveisCriticas.value = responseVariaveisCriticas.data.variaveisCriticas;
                } catch (error) {
                    erro.value = 'Erro ao carregar as variaveis criticas.';
                    console.error(error);
                }
            };


            const carregarHorasOperacao = async () => {
                try {
                    const response = await axios.get(`https://peconnect.com.br/api/equipamento/${equipamentoId}/an`);
                    if (response.data && typeof response.data.horas === "number") {
                        horasOperacao.value = Math.floor(response.data.horas); // arredonda para baixo, sem casas decimais
                    }
                } catch (error) {
                    console.error("Erro ao carregar horas de operação:", error);
                }
            };

            let intervaloAlarmes;
            let intervaloGrafico;
            let intervaloVariaveis;
            let intervaloVariaveisCriticas;

            let intervaloHorasOperacao;
            let intervaloStatus;

            onMounted(() => {
                carregarEquipamento();
                carregarHorasOperacao();
                carregarStatus();
                intervaloHorasOperacao = setInterval(carregarHorasOperacao, 3000);
                intervaloGrafico = setInterval(buscarDadosGrafico, 3000);
                intervaloVariaveis = setInterval(buscarVariaveisCirucito, 3000);
                intervaloVariaveisCriticas = setInterval(carregarVariaveisCriticas, 3000);
                intervaloStatus = setInterval(carregarStatus, 3000);
            });

            onUnmounted(() => {
                clearInterval(intervaloAlarmes);
                clearInterval(intervaloGrafico);
                clearInterval(intervaloVariaveis);
                clearInterval(intervaloVariaveisCriticas);
                clearInterval(intervaloHorasOperacao);
                clearInterval(intervaloStatus);
            });

            return {
                erro,
                equipamento,
                variaveisCriticas,
                circuitoSelecionado,
                variaveisCircuito,
                dadosGrafico,
                selecionarCircuito,
                buscarVariaveisCirucito,
                equipamentoId,
                horasOperacao,
                statusOperacao
            };
        }
    };
</script>

<style scoped>
/* ---------- BOTÕES DE STATUS ---------- */
.status-ligado,
.status-parado,
.status-inativo {
    border-radius: 80px;
    width: 102px;
    /* mesmo tamanho do container */
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style>
.imagem-equipamento {
    height: 220px;
    width: 100%;
    background-size: contain;
    background-position: left center;
    background-repeat: no-repeat;
    margin-left: -30px !important;
}

.box-titulo-status {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 142px;
    height: 22px;
    top: 90px;
    left: 284px;
    border-radius: 5px;
    background: var(--linear-azul);
    margin-bottom: 14px;

    label {
        font-weight: 600;
        font-size: 16px;
        line-height: 18.75px;
        text-align: right;
    }
}

.container-status {
    display: grid;
    gap: 10px;
    width: 142px;
    margin-bottom: 12px;
}

.box-status {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.box-descricao-status {
    width: 102px;
    height: 40px;
    border-radius: 80px;
    display: flex;
    align-items: center;
    justify-content: center;

    label {
        font-weight: 400;
        font-size: 14px;
        line-height: 16.41px;
        text-align: center;
    }
}

.circulo {
    width: 30px;
    height: 30px;
    border-radius: 100%;
}



/* Para o tema Dark */
body[data-theme="dark"] .status-ligado {
    background: rgba(12, 164, 46, 0.30);
    border: 2px solid #0CA42E;
}

body[data-theme="dark"] .status-parado {
    background: rgba(163, 16, 16, 0.30);
    border: 2px solid #A31010;
}

body[data-theme="dark"] .status-inativo {
    background: #17212E;
    border: 2px solid #6C6C6C;
}

/* Para o tema light */
body[data-theme="light"] .status-ligado {
    background: rgba(12, 164, 46, 0.70);
    border: 2px solid #0CA42E;
}

body[data-theme="light"] .status-parado {
    background: rgba(163, 16, 16, 0.65);
    border: 2px solid #A31010;
}

body[data-theme="light"] .status-inativo {
    background: rgba(92, 97, 102, 0.70);
    border: 2px solid #6C6C6C;
}

.box-tempo-operacao {
    display: flex;
    flex-direction: column;
    align-items: center;
    white-space: nowrap;
    align-content: flex-start;
    flex-wrap: wrap;
}

.descricao-tempo {
    font-weight: 700;
    font-style: italic;
    font-size: 18px;
    line-height: 21.09px;
    text-align: center;
    color: var(--fonte-vermelha);
}

.quantidade-tempo {
    font-weight: 700;
    font-style: italic;
    font-size: 18px;
    line-height: 21.09px;
    text-align: center;
    color: #0069AD;
}

.botao-log {
    width: 72px;
    height: 20px;
    border-radius: 5px;
    padding-right: 10px;
    padding-left: 10px;
    background: linear-gradient(90.25deg, #0069AD 0.24%, #004A7A 88.06%);
    display: flex;
    align-items: center;
    justify-content: center;

    label {
        background: url("../assets/log.svg") no-repeat center center;
        background-size: contain;
        width: 30px;
        height: 15px;
    }
}

.box-variaveis-criticas {
    width: 100%;
    height: 22px;
    border-radius: 5px;
    background: var(--linear-branco-invertido);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
    margin-bottom: 12px;

    label {
        font-weight: 600;
        font-size: 14px;
        line-height: 16.41px;
    }

}

.descricao-variavel-critica {
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    text-align: center;

    min-height: 38px;

    display: flex;
    align-items: center;
    /* centraliza verticalmente */
    justify-content: center;
    /* centraliza horizontalmente */
    margin-bottom: 4px;
}



.linha-circuito {
    padding: 10px 0px 10px 0px;
}

.box-circuito {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    border-radius: 5px;
    border-width: 1px;
    padding-right: 10px;
    padding-left: 10px;
    gap: 10px;
    background-color: var(--cinza-destaque);

    p {
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
    }
}

.circuito-desativado {
    opacity: 0.3;
}

.circuito-selecionado {
    border: 1px solid #2983DD;
}

.linha-titulo-variaveis {
    padding-bottom: 5px;
}

.box-titulo-variaveis {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 22px;
    border-radius: 5px;
    background: var(--linear-branco-invertido);
    padding-left: 10px;

    label {
        font-weight: 600;
        font-size: 14px;
        line-height: 16.41px;
    }
}

.box-variavel {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    height: 60px;
    border-radius: 5px;
    background-color: var(--cinza-claro);
}

.col-botao-log {
    display: flex;
    justify-content: center;
}

@media screen and (max-width: 640px) {
    .box-variavel {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        padding: 10px 20px 10px 20px;
        justify-content: space-between;
    }

}

.box-tempo-operacao {
    align-content: center;
}

.col-botao-log {
    justify-content: center !important;
}

.label-descricao {
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    text-align: center;
}

.label-valor {
    font-weight: 600;
    font-size: 20px;
    line-height: 23.44px;
    text-align: center;
}

.box-gestao-energetica {
    display: flex;
    align-items: center;
    width: 171px;
    height: 40px;
    border-radius: 5px;
    padding-right: 10px;
    padding-left: 10px;
    background: linear-gradient(90deg, #0069AD 0%, #004A7A 100%);
    justify-content: space-between;
    padding: 5px;
}

.fonte-clara {
    color: #E9E9E9;
}

.container-header-mobile {
    display: none;
}

.container-header-tablet {
    display: none;
}

.container-varaiveis-criticas {
    padding-top: 12px;
}

.container-diagnostico {
    margin-top: 30px;
}

@media (max-width: 960px) and (min-width: 431px) {
    .container-header-tablet {
        display: flex;
    }

    .ocultar-tablet {
        display: none !important;
    }

    .ocultar-mobile {
        display: none !important;
    }

    .col-botao-log {
        justify-content: flex-start;
    }

    .container-header-mobile {
        display: flex;
    }

    .container-nome {
        gap: 10px;
    }

    .box-nome {
        background: var(--linear-branco-invertido);
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
    }

    .botao-log {
        width: 100%;
    }

    .box-gestao-energetica {
        width: 100%;
        padding: 0px 8px 0px 8px;
    }

    .box-alarme {
        width: 100%;
    }

    .container-dados-equipamento {
        margin-top: 10px !important;
        align-items: flex-start;
    }

}

@media (max-width: 430px) {
    .ocultar-mobile {
        display: none !important;
    }

    .col-botao-log {
        justify-content: flex-start;
    }

    .container-header-mobile {
        display: flex;
    }

    .container-nome {
        gap: 10px;
    }

    .box-nome {
        background: var(--linear-branco-invertido);
        border-radius: 5px;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
    }

    .botao-log {
        width: 100%;
    }

    .box-gestao-energetica {
        width: 100%;
        padding: 0px 8px 0px 8px;
    }

    .box-alarme {
        width: 100%;
    }

    .container-dados-equipamento {
        margin-top: 10px !important;
        align-items: flex-start;
    }
}


.box-operacao {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: center;
    gap: 5px;
    margin: 4px 0 0;
}

/* grid que se auto‑encaixa: */
.gauges-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    gap: 12px;
}

.box-gauge {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.status-ligado {
    background: rgba(12, 164, 46, .30);
    border: 2px solid #0CA42E;
}

.status-parado {
    background: rgba(163, 16, 16, .30);
    border: 2px solid #A31010;
}

.status-inativo {
    background: #17212E;
    border: 2px solid #6C6C6C;
}

.rodape-plant {
    margin-top: 40px;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-color);
    opacity: 0.7;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.bloco-status-operacao {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 100%;
}

.v-col.d-flex.align-center.pa-0 {
    height: 100%;
}

.linha-status-imagem {
    height: 100%;
    align-items: stretch;
}

.linha-status-imagem .v-col {
    height: 100%;
}
</style>